import { Reducer } from 'redux'

import { ErrorType, APIState, APIActions } from 'types'

export const ApiActionTypes = {
  REQUEST_DATA: 'REQUEST_DATA',
  RECEIVE_DATA: 'RECEIVE_DATA',
  HANDLE_ERROR: 'HANDLE_ERROR',
  RESET: 'RESET',
  CLEAR: 'CLEAR',
  RESET_LOADING: 'RESET_LOADING',
  RESET_ERROR: 'RESET_ERROR',
  UNKNOWN_ERROR: 'UNKNOWN_ERROR',
}

/**
 * Factory for reducer that communicates with the api.
 * Use combinereducer for extending this with other functionality
 */
export default function createApiReducer(prefix: string): Reducer<APIState> {
  const initialState: APIState = {
    isLoading: false,
    error: null,
    data: null,
  }
  return function reducer(state: APIState = initialState, action: APIActions) {
    switch (action.type) {
      case `${prefix}/${ApiActionTypes.REQUEST_DATA}`:
        return {
          ...state,
          isLoading: true,
        }
      case `${prefix}/${ApiActionTypes.RECEIVE_DATA}`:
        return {
          ...state,
          isLoading: false,
          error: null,
          data: action.data,
        }
      case `${prefix}/${ApiActionTypes.HANDLE_ERROR}`:
        return {
          ...state,
          isLoading: false,
          error: action.error,
        }
      case `${prefix}/${ApiActionTypes.RESET}`:
        return {
          ...state,
          isLoading: false,
          error: null,
          data: action.data,
        }
      case `${prefix}/${ApiActionTypes.RESET_LOADING}`:
        return {
          ...state,
          isLoading: false,
        }
      case `${prefix}/${ApiActionTypes.RESET_ERROR}`:
        return {
          ...state,
          error: null,
        }
      // Unprefixed actions for general functionality
      // Clear action resets state to initial empty state
      case `${ApiActionTypes.CLEAR}`:
        return initialState
      default:
        return state
    }
  }
}

type RequestDataType = (
  prefix: string,
) => () => {
  type: string
  isLoading: boolean
}

export const requestDataFor: RequestDataType = prefix => {
  return () => {
    return {
      type: `${prefix}/${ApiActionTypes.REQUEST_DATA}`,
      isLoading: true,
    }
  }
}

type ReceiveDataType = (
  prefix: string,
) => (
  data: any,
) => {
  type: string
  isLoading: boolean
  data: any
}

export const receiveDataFor: ReceiveDataType = prefix => {
  return data => {
    return {
      type: `${prefix}/${ApiActionTypes.RECEIVE_DATA}`,
      isLoading: false,
      data,
    }
  }
}

export const resetLoading = (prefix: string) => {
  return () => {
    return {
      type: `${prefix}/${ApiActionTypes.RESET_LOADING}`,
      isLoading: false,
    }
  }
}

export const resetErrorFor = (prefix: string) => {
  return () => {
    return {
      type: `${prefix}/${ApiActionTypes.RESET_ERROR}`,
    }
  }
}

export const handleErrorFor = (prefix: string) => {
  return (error: ErrorType, data?: any) => {
    return {
      type: `${prefix}/${ApiActionTypes.HANDLE_ERROR}`,
      isLoading: false,
      error,
      data: data || null,
    }
  }
}

export const resetDataFor = (prefix: string) => {
  return (data?: any) => {
    return {
      type: `${prefix}/${ApiActionTypes.RESET}`,
      data,
    }
  }
}

export const clearData = () => {
  return {
    type: `${ApiActionTypes.CLEAR}`,
  }
}
